import script from "./noteBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./noteBubble.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=4893aea8&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4893aea8"]])

export default __exports__